
export default class Errors
{
    constructor() {
        this.items = [];
    }

    clear() {
        this.items = [];
    }

    clearField(field) {
        this.items = this.items.filter(item => item.field !== field);
    }

    add(field, message) {

        for (var i = 0; i < this.items.length; i++) {
             if (this.items[i].field == field) {
                 if (typeof message == "object") {
                     this.items[i].messages.push(...message);
                 } else {
                     this.items[i].messages.push(message);
                 }

                 return
             }
        }

        message = typeof message === "object" ? message : [message];

        this.items.push({
            field: field,
            messages: message
        })
    }

    addAll(fields) {
        for (let field in fields) {
            this.add(field, fields[field]);
        }
    }

    has(field) {
        for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].field == field) {
                return true;
            }
        }

        return false;
    }

    any() {
        if (this.items.length > 0) {
            return true;
        }

        return false;
    }

    get(field) {
        for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].field == field) {
                return this.items[i].messages;
            }
        }

        return [];
    }

    all() {
        return this.items;
    }
}
